import { Button } from "@workspace/ui/components/button";
import { cn } from "@workspace/ui/lib/utils";
import { AnimatePresence, domAnimation, LazyMotion, m } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

const FaqItem = ({
  question,
  answer,
  index,
}: {
  question: string;
  answer: string;
  index: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        animate={{ opacity: 1, y: 0 }}
        className={cn(
          "group rounded-lg",
          "transition-all duration-200 ease-in-out",
          "border border-border/50",
          isOpen
            ? "bg-linear-to-br from-background via-muted/50 to-background"
            : "hover:bg-muted/50"
        )}
        initial={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.2, delay: index * 0.1 }}
      >
        <Button
          className="h-auto w-full justify-between px-6 py-4 hover:bg-transparent"
          onClick={() => setIsOpen(!isOpen)}
          variant="ghost"
        >
          <h3
            className={cn(
              "max-w-[calc(100%-2rem)] overflow-hidden truncate text-ellipsis text-left font-medium text-sm transition-colors duration-200 md:text-base",
              "text-foreground/70",
              isOpen && "whitespace-normal text-foreground"
            )}
          >
            {question}
          </h3>
          <m.div
            animate={{
              rotate: isOpen ? 180 : 0,
              scale: isOpen ? 1.1 : 1,
            }}
            className={cn(
              "shrink-0 rounded-full p-0.5",
              "transition-colors duration-200",
              isOpen ? "text-primary" : "text-muted-foreground"
            )}
            transition={{ duration: 0.2 }}
          >
            <ChevronDown className="h-4 w-4" />
          </m.div>
        </Button>
        <AnimatePresence initial={false}>
          {isOpen && (
            <m.div
              animate={{
                height: "auto",
                opacity: 1,
                transition: { duration: 0.2, ease: "easeOut" },
              }}
              exit={{
                height: 0,
                opacity: 0,
                transition: { duration: 0.2, ease: "easeIn" },
              }}
              initial={{ height: 0, opacity: 0 }}
            >
              <div className="px-6 pt-2 pb-4">
                <m.p
                  animate={{ y: 0, opacity: 1 }}
                  className="text-muted-foreground text-sm leading-relaxed"
                  exit={{ y: -10, opacity: 0 }}
                  initial={{ y: -10, opacity: 0 }}
                >
                  {answer}
                </m.p>
              </div>
            </m.div>
          )}
        </AnimatePresence>
      </m.div>
    </LazyMotion>
  );
};
FaqItem.displayName = "FaqItem";

export { FaqItem };
